import React from 'react';
import { Dropdown, DropdownItem } from '../Dropdown';
import { IPosition } from '../shared/IPosition';
import { DateTime, Duration } from 'luxon';

export const getDateFromDays = (days: number): [string, string] => [
  DateTime.local().plus(Duration.fromObject({ days })).toFormat('yyyy-MM-dd'),
  DateTime.local().toFormat('yyyy-MM-dd'),
];

const isSameDay = ([startDate, endDate]: [string, string], [startDate2, endDate2]: [string, string]) =>
  DateTime.fromISO(startDate).startOf('day').equals(DateTime.fromISO(startDate2).startOf('day')) &&
  DateTime.fromISO(endDate).startOf('day').equals(DateTime.fromISO(endDate2).startOf('day'));

interface IDateRangeDropdownFilterProps {
  position: IPosition;
  date?: [string, string];
  onChange: (date: [string, string]) => void;
}

export const DateRangeDropdown: React.FC<IDateRangeDropdownFilterProps> = ({ position, date, onChange }) => (
  <Dropdown position={position} isInline={false} show={true} zIndex={0}>
    <DropdownItem
      isSelectable={true}
      onClick={() => onChange(getDateFromDays(-30))}
      selected={!!date && isSameDay(date, getDateFromDays(-30))}
    >
      30 Days
    </DropdownItem>
    <DropdownItem
      isSelectable={true}
      onClick={() => onChange(getDateFromDays(-60))}
      selected={!!date && isSameDay(date, getDateFromDays(-60))}
    >
      60 Days
    </DropdownItem>
    <DropdownItem
      isSelectable={true}
      onClick={() => onChange(getDateFromDays(-90))}
      selected={!!date && isSameDay(date, getDateFromDays(-90))}
    >
      90 Days
    </DropdownItem>
    <DropdownItem
      isSelectable={true}
      onClick={() => onChange(['CUSTOM', 'CUSTOM'])}
      selected={!!date && date[0] === 'CUSTOM' && date[1] === 'CUSTOM'}
    >
      Custom Range...
    </DropdownItem>
  </Dropdown>
);
